import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type OrganisationsState = {
  selectedId: string | null
}

// A shared or bookmarked link's explicit org parameter wins over the
// remembered selection and becomes the new remembered selection.
export const resolveInitialOrganisationId = () => {
  if (typeof window !== 'undefined') {
    const urlOrg = new URLSearchParams(window.location.search).get('org')
    if (urlOrg) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('selectedOrganisationId', urlOrg)
      }
      return urlOrg
    }
  }

  return (
    (typeof localStorage !== 'undefined' &&
      localStorage.getItem('selectedOrganisationId')) ||
    null
  )
}

const initialState: OrganisationsState = {
  selectedId: resolveInitialOrganisationId()
}

export const organisationsSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    setSelectedOrganisationId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      localStorage.setItem('selectedOrganisationId', action.payload || '')
      // Set query parameter without reloading the page
      const url = new URL(window.location.href)
      if (action.payload) {
        url.searchParams.set('org', action.payload)
      } else {
        url.searchParams.delete('org')
      }
      window.history.replaceState({}, '', url.toString())
      state.selectedId = action.payload
    }
  }
})

export const reducer = organisationsSlice.reducer

export const { setSelectedOrganisationId } = organisationsSlice.actions

export const handleOrganisationSwitch =
  (organisationId: string | null) => (dispatch: any) => {
    dispatch(
      organisationsSlice.actions.setSelectedOrganisationId(organisationId)
    )
  }
